module.exports = __webpack_public_path__ + "static/media/profile-splash.9ca97ca1.JPG";